import "./HowToUseSteps.css";

const DEFAULT_STEPS = [
  { icon: "🛒", title: "Add to Selections", body: "Select your item and tap Add to Selections or Buy Now." },
  { icon: "📱", title: "Pay via M-Pesa",  body: "Enter your M-Pesa PIN on the STK push prompt. Funds are held in escrow." },
  { icon: "📦", title: "We Source & Ship", body: "We procure your item from the supplier and arrange last-mile delivery." },
  { icon: "✅", title: "Confirm & Release", body: "Confirm receipt to release payment. Any issue? Contact us for a 14-day return." },
];

const HowToUseSteps = ({ steps = DEFAULT_STEPS, title = "How It Works" }) => (
  <div className="htu-wrap">
    <p className="htu-title">{title}</p>
    <ol className="htu-steps">
      {steps.map((step, i) => (
        <li key={i} className="htu-step">
          <span className="htu-num" aria-hidden="true">{i + 1}</span>
          <span className="htu-icon" aria-hidden="true">{step.icon}</span>
          <div className="htu-body">
            <p className="htu-step-title">{step.title}</p>
            <p className="htu-step-body">{step.body}</p>
          </div>
        </li>
      ))}
    </ol>
  </div>
);

export default HowToUseSteps;
